import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const classicSoftwareBoardSettingsInsightsRapidboardBoardRoute: InvariantJiraRoute = {
	name: 'rapidboard-board',
	path: '/jira/software/c/projects/:projectKey/boards/:boardId',
	query: ['config=insightsConfig'],
};
